// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1qrgX","rowsWrapper":"style_rowsWrapper__2iZwI","rowWrapper":"style_rowWrapper__2tTrW"};